export default __webpack_public_path__ + "static/media/dr.48e0d6ba.jpg";